import PropTypes from "prop-types";
import React, { Component } from "react";

const DEFAULT_AVATAR_SIZE = 40;

class Avatar extends Component {
    render() {
        const { name, size, src } = this.props;

        const height = size || DEFAULT_AVATAR_SIZE;
        const width = size || DEFAULT_AVATAR_SIZE;
        const avatarStyles = {
            fontSize: height * 0.65,
            height,
            lineHeight: `${height}px`,
            width,
        };

        let avatar;
        if (src) {
            avatar = <img alt={name} src={src} className="avatar" height={height} width={width} style={avatarStyles} />;
        } else if (name) {
            avatar = (
                <span className="avatar has-no-src" style={avatarStyles}>
                    {name.charAt(0)}
                </span>
            );
        } else {
            avatar = <span className="avatar has-no-name" style={avatarStyles} />;
        }

        return avatar;
    }
}

Avatar.propTypes = {
    name: PropTypes.string,
    size: PropTypes.number,
    src: PropTypes.string,
};

export default Avatar;
